/**
 * Translation utilities for reports
 */

import { CredentialRequestStatus, CredentialType } from "@/models/credentialRequest";

/**
 * Translate status to Spanish
 */
export function translateStatus(status: string | null): string {
  if (!status) return "—";
  
  const statusMap: Record<string, string> = {
    DRAFT: "Borrador",
    SUBMITTED: "Enviado",
    APPROVED: "Aprobado",
    REJECTED: "Rechazado",
    PRINTED: "Impreso",
    DELIVERED: "Entregado",
  };

  return statusMap[status] || status;
}

/**
 * Translate credential type to Spanish
 */
export function translateCredentialType(type: string | null): string {
  if (!type) return "—";
  
  const typeMap: Record<string, string> = {
    MINISTERIAL: "Ministerial",
    INSTITUTION: "Institución",
    FUNCTION: "Función",
  };

  return typeMap[type] || type;
}

/**
 * Get all status labels in Spanish
 */
export const STATUS_LABELS = [
  { value: CredentialRequestStatus.DRAFT, label: "Borrador" },
  { value: CredentialRequestStatus.SUBMITTED, label: "Enviado" },
  { value: CredentialRequestStatus.APPROVED, label: "Aprobado" },
  { value: CredentialRequestStatus.REJECTED, label: "Rechazado" },
  { value: CredentialRequestStatus.PRINTED, label: "Impreso" },
  { value: CredentialRequestStatus.DELIVERED, label: "Entregado" },
];

/**
 * Get all credential type labels in Spanish
 */
export const CREDENTIAL_TYPE_LABELS = [
  { value: CredentialType.MINISTERIAL, label: "Ministerial" },
  { value: CredentialType.INSTITUTION, label: "Institución" },
  { value: CredentialType.FUNCTION, label: "Función" },
];
